import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=b9e39992&scoped=true&"
import script from "./Settings.vue?vue&type=script&lang=js&"
export * from "./Settings.vue?vue&type=script&lang=js&"
import style0 from "@fortawesome/fontawesome-free-webfonts/css/fa-solid.css?vue&type=style&index=0&id=b9e39992&lang=css&scoped=true&"
import style1 from "@fortawesome/fontawesome-free-webfonts/css/fontawesome.css?vue&type=style&index=1&id=b9e39992&lang=css&scoped=true&"
import style2 from "@/styles/toolbar.css?vue&type=style&index=2&id=b9e39992&lang=css&scoped=true&"
import style3 from "@/styles/option.css?vue&type=style&index=3&id=b9e39992&lang=css&scoped=true&"
import style4 from "./Settings.vue?vue&type=style&index=4&id=b9e39992&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9e39992",
  null
  
)

export default component.exports